export default "__VITE_ASSET__DdX33caC__"